import React from "react";
import { PatternBackground } from "../../components/PatternBackground";
import MembersTable from "./MembersTable";

export const MemberPage = () => {
  return (
    <div>
      <PatternBackground>
        <h1 className="fw-bold mb-3">Members</h1>
        <small>Create and manage all pension scheme members</small>
      </PatternBackground>
      
      <div className="om-container">
        <div className="p-4 shadow-sm bg-white rounded">
          <div className="mt-1">
            <MembersTable />
          </div>
        </div>
      </div>
    </div>
  );
};
